import { createContext } from 'react';

export const PermissionContext = createContext({privileges:[],isAdmin:false,hasAccess:(p)=>false});
export const extractPrivileges = (userPermissionsBasedOnClinic,userRole,clinicId)=>{
    const isAdmin = !!userRole?.isAdmin;
    const fullAccess = isAdmin && !!userRole?.fullAccess;
    let privileges = [],permissions={},permissionsLoaded=fullAccess;
    if(isAdmin && userPermissionsBasedOnClinic.isAdmin && userRole.current?.length){
      permissionsLoaded = true;
      privileges = [...userRole.current.map(role => userPermissionsBasedOnClinic[role] || []).flat()];
    }
    else if (!isAdmin && userRole && userRole[clinicId] && userPermissionsBasedOnClinic[clinicId]) {
        permissionsLoaded = true;
        userRole[clinicId].forEach(role => {
        permissions = userPermissionsBasedOnClinic[clinicId][role] || [];
        const cPriv = Array.isArray(permissions)?permissions:[...(permissions["READ"] || []),...(permissions["WRITE"] || [])]
        privileges = [...privileges,...cPriv];
      });
    }
    const hasAccess = (privilege)=>{
      return fullAccess || privileges.includes(privilege);
    }
    //permissionsLoaded && console.log("permissionsLoaded",privileges);
    return {privileges,permissionsLoaded,isAdmin,hasAccess};
}  